import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  r2Yes,
  r2No,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const fieldId = 'first_site_implementation_b';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_BUTTON_SELECTOR);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an answer' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = [];

const vFParams = {
  multiSelect: false,
  fieldTitle: 'Did the change fail on the first implementation?',
};

const riskLevelParams = {
  weight: 0.4,
  score: {
    [r2Yes]: 4,
    [r2No]: 1,
  },
};

const firstSiteImplementationBParams = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  riskLevelParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { firstSiteImplementationBParams };
